import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import { Form, textBox } from "trader.ts/ui.forms";
import { renderSaveButton } from "../../client/savebutton";
import { rpc } from "trader.ts/network";

export function render(opts: {}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("password1", [], () =>
      textBox({ type: "password", label: "Wachtwoord" }),
    )
    .addField("password2", [], () =>
      textBox({ type: "password", label: "Herhaal wachtwoord" }),
    )
    .build();
  return (
    <div className={style.card + style.card_large + style.card_accent}>
      <h1>{"Stel je wachtwoord in"}</h1>
      {form.render()}
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) => rpc(routes.saveNewPasswordSpec, undefined, values),
          reload: false,
        })}
      </div>
    </div>
  );
}
